import '.i8{flex:2;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { MiniCard } from '@app/components/blocks/card/MiniCard'
import { Text } from '@app/components/core/typography/Text'
import { styled } from 'inlines'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { Suspense } from 'react'
import { AddressModel, labelAddressBuilder } from '@app/util/helpers'
import { useTranslations } from '@i18n/useLanguage'

// const MultiMarkerMap = lazy(() =>
//   import('@app/components/core/map/MultiMarkerMap').then((module) => ({
//     default: module.MultiMarkerMap,
//   })),
// )

type SearchMapItem = {
  id: string
  image: string
  title: string
  description?: string
  address: AddressModel
  status?: string
  lat: number
  long: number
}

export type SearchMapProps = {
  items: SearchMapItem[]
  totalItems: number
  title: string
  subtitle: string
  searchTerm?: string
  isLoading: boolean
  moreToLoad: boolean
  loadMore: () => void
  onResetSearch: () => void
}

export const SearchMap = ({
  items,
  totalItems: _totalItems,
  subtitle,
  searchTerm: _searchTerm,
  isLoading: _isLoading,
  moreToLoad: _moreToLoad,
  loadMore: _loadMore,
  onResetSearch: _onResetSearch,
}: SearchMapProps) => {
  const t = useTranslations().app
  const [_location, navigate] = useLocation()

  return (
    <Row>
      <Column
        alignItems="stretch"
        style={{ width: '25rem', height: '55rem', overflowY: 'auto' }}
      >
        <Text.Small color="var(--shades-blue-400)">{subtitle}</Text.Small>
        {items &&
          items.map((item) => (
            <MiniCard
              key={item.id}
              onClick={() => navigate(pages.plot(item.id))}
              {...item}
              location={labelAddressBuilder(
                item.address,
                t.common.notSpecified,
              )}
            />
          ))}
      </Column>
      <Suspense>
        <div className="i8">
          {/* <MultiMarkerMap
            markers={items.map((item) => ({ lat: item.lat, long: item.long }))}
            zoom={9}
            height="55rem"
          /> */}
        </div>
      </Suspense>
    </Row>
  )
}
